<template>
  <v-layout>
    <div class="padding-container-lg">
      <v-page-header>
        <!-- <span slot="header">
          <h4>Create care plan</h4>
        </span> -->
        <div slot="action">
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="importCareplan"
          >
            <i class="icon ion-md-add" />
            Clone
          </button>
          <b-modal
            id="modal-center"
            ref="myModalRef"
            body-class="pt-0"
            :footer-class="`display-none`"
            centered
            title="Import care plan"
          >
            <div class="row">
              <div class="col col-md-12 col-12 position-fixed p-3 search-bar-content">
                <b-form-input
                  v-model="searchText"
                  type="text"
                  placeholder="Enter care plan name or ID"
                  class="search-bar"
                />
              </div>
              <div class="col col-md-12 col-12 mt-5 template-content">
                <div
                  v-if="(clonedCareplanTemplates &&
                    !clonedCareplanTemplates.length || !clonedCareplanTemplates)
                  && !templateLoading"
                  class="d-flex justify-content-center"
                >
                  No Data found
                </div>
                <div
                  v-for="template in clonedCareplanTemplates"
                  :key="template.id"
                  class="template"
                  @click="setTemplate(template.id)"
                >
                  <label><span>{{ template.title }}</span></label>
                  <p> {{ template.plan_no }}</p>
                  <div class="template-detail">
                    <span>Duration: {{ template.plan_duration }} days</span>
                    <span>Prescriptions: {{ template.interventions }}</span>
                    <span>Side Effects/Symptoms: {{ template.assessments }}</span>
                  </div>
                </div>
              </div>
            </div>
          </b-modal>
        </div>
      </v-page-header>
      <div>
        <v-create-care-plan
          @onSubmit="onSubmit"
          :carePlan="carePlan"
          type="create"
        />
      </div>
      <div
        v-for="(accordion, key) in accordionList"
        :key="key"
        class="disable-accordian-list"
      >{{ accordion.name }}
        <span class="pull-right">
          <span>Add</span>
          <i class="icon ion-md-add" />
        </span>
      </div>
    </div>
  </v-layout>
</template>

<script>

import VLayout from '@/layouts/Default.vue';
import VPageHeader from '@/components/pageheader/PageHeader.vue';
import VCreateCarePlan from '@/components/careplan/Modify.vue';
import { mapGetters } from 'vuex';

import moment from 'moment';

export default {
  name: 'CreateCareplan',
  components: { VCreateCarePlan, VLayout, VPageHeader },
  data() {
    return {
      accordionList: [
        {
          name: 'Prescriptions'
        },
        {
          name: 'Side Effects/Symptoms'
        },
        {
          name: 'Note Instruction'
        }
      ],
      searchText: '',
      clonedCareplanTemplates: [],
      carePlan: {
        title: '',
        category_id: null,
        goal: '',
        problem: '',
        plan_duration: '',
        cycles: '',
        break_time: '',
        plan_start_date: this.getFormattedDate(new Date()),
        plan_end_date: this.getFormattedDate(moment().add(20, 'years')),
        is_enrollment: false
      }
    };
  },
  computed: {
    ...mapGetters({
      careplanTemplates: 'careplan/getCareplanTemplates',
      selectedTemplate: 'careplan/getCareplanTemplate',
      templateLoading: 'careplan/getLoading',
      organisationId: 'auth/getOrganisationId'
    })
  },
  watch: {
    searchText: 'searchCarePlanTemplate',
    careplanTemplates(value) {
      if (!this.clonedCareplanTemplates.length) {
        this.clonedCareplanTemplates = value;
      }
    }
  },
  methods: {
    importCareplan() {
      this.$store.dispatch('careplan/getTemplates');
      this.$refs.myModalRef.show();
      this.searchText = '';
    },
    onSubmit(data) {
      this.$store.dispatch('careplan/create', data);
    },
    setTemplate(id) {
      this.$router.push({
        name: 'careplan.viewTemplate', params: { id }
      });
      this.$refs.myModalRef.hide();
    },
    searchCarePlanTemplate(value) {
      const filteredTemplate = [];
      this.careplanTemplates.filter((template) => {
        const { title } = template;
        const planNo = template.plan_no;
        if (title.includes(value) || planNo.includes(value)) {
          filteredTemplate.push(template);
        }
        return true;
      });
      this.clonedCareplanTemplates = filteredTemplate;
    }
  }
};
</script>
<style lang="scss" scoped>
  @import './style.scss';
</style>
